import { render, staticRenderFns } from "./IstanbulBombing.vue?vue&type=template&id=7a9b9f36&lang=pug&"
import script from "./IstanbulBombing.vue?vue&type=script&lang=js&"
export * from "./IstanbulBombing.vue?vue&type=script&lang=js&"
import style0 from "./IstanbulBombing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports